export default __webpack_public_path__ + "static/assets/SL-X-grey-light.f3695345.png";